import { createContext } from 'react';
import { Language } from '../valueobject/language.ts';

export interface LanguageContext {
  currentLanguage: Language;
  changeLanguage: (language: Language) => void;
}

/**
 * LanguageContextProvider is a React Context object that provides the current language settings
 * and a function to change the language in a React application.
 *
 * This context allows components to access and update language-related information,
 * enabling support for internationalization and localization.
 *
 * The context value comprises:
 * - currentLanguage: Represents the current selected language from the `Language` enumeration.
 * - changeLanguage: A function that can be invoked to update the `currentLanguage`.
 */
export const LanguageContextProvider = createContext<LanguageContext>({
  currentLanguage: Language.EN,
  changeLanguage: () => {},
});
